import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceForecasts from "@/pages/IntelligenceForecasts";

export const Route = createFileRoute("/_app/intelligence/forecasts/")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceForecasts /></PageGate>
  ),
});
